module.exports = __webpack_public_path__ + "static/media/hanson-lu-_8EFj6ISA08-unsplash.f2ba6cbd.jpg";